const INTERNAL_FILTER_KEYS = new Set(['sortBy', 'sortOrder']);

export function formatFilterLabel(meta, key, value) {
  if (value === '' || value === null || value === undefined) return null;
  if (INTERNAL_FILTER_KEYS.has(key)) return null;
  const def = (meta?.filters || []).find((f) => f.key === key);
  if (!def) return `${key}=${value}`;
  if (def.type === 'boolean') return value ? def.label : null;
  if (def.options?.length) {
    const opt = def.options.find((o) => String(o.value) === String(value));
    if (opt) return `${def.label}: ${opt.label}`;
  }
  return `${def.label}: ${value}`;
}

export function formatAppliedFilterChip(filter, sectionMeta) {
  if (!filter) return '';

  if (filter.displayLabel) return filter.displayLabel;
  if (filter.label && filter.displayValue != null) {
    return `${filter.label}: ${filter.displayValue}`;
  }

  if (sectionMeta) {
    const fromMeta = formatFilterLabel(sectionMeta, filter.key, filter.value);
    if (fromMeta) return fromMeta;
  }

  return `${filter.key}: ${filter.value}`;
}

export function formatPageFilterSummary(page, meta) {
  if (!page?.filters) return [];

  return Object.entries(page.filters)
    .map(([key, value]) => formatFilterLabel(meta, key, value))
    .filter(Boolean);
}
